import { render, staticRenderFns } from "./LmSimpleCard.vue?vue&type=template&id=341a98c2&scoped=true"
import script from "./LmSimpleCard.vue?vue&type=script&lang=js"
export * from "./LmSimpleCard.vue?vue&type=script&lang=js"
import style0 from "./LmSimpleCard.vue?vue&type=style&index=0&id=341a98c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341a98c2",
  null
  
)

export default component.exports